import { UserManager } from 'oidc-client'

const oidcSettings = {
  authority: `${process.env.REACT_APP_OIDC_AUTHORITY}`, // Votre serveur d'authentification
  client_id: `${process.env.REACT_APP_OIDC_CLIENT_ID}`,
  redirect_uri: `${process.env.REACT_APP_OIDC_REDIRECT_URI}`,
  response_type: `${process.env.REACT_APP_OIDC_RESPONSE_TYPE}`,
  scope: `${process.env.REACT_APP_OIDC_SCOPE}`,
  post_logout_redirect_uri: `${process.env.REACT_APP_OIDC_LOGOUT_REDIRECT_URI}`,
}

const userManager = new UserManager(oidcSettings)

export default userManager
